<div class="not-found__container">
    <div class="not-found__wrapper">
        <div class="not-found__image">
            <img ngSrc="./././assets/img/undraw_a_day_at_the_park.svg" class="img-fluid" alt="undraw day park"
                 fill>
        </div>
        <div class="not-found__message">
            <h1>Página não encontrada!</h1>
            <ui-button
                type="button"
                variant="link"
                (click)="location.back()"
            >
                Voltar a página anterior
            </ui-button>
        </div>
    </div>
</div>
